import { useSettings } from '@capsicum/common';
import { useWCPledgeTokensTab, useWCPledgeTokensTabTexts } from '@capsicum/features/world-championship-pledge/shared';
import { useState } from 'react';

import { WCPledgeCountryCard, WCPledgePartneredTeamCard, WCPledgeSearchSection } from '../../ui/tokensTab';

import * as S from './WCPledgeTabs.styled';

export const WCPledgeTokensTab = () => {
	const { filtersTexts, searchPlaceholder, selectAllCheckboxLabel, title } = useWCPledgeTokensTabTexts();
	const [searchText, setSearchText] = useState<string>('');
	const [selectedFilter, setSelectedFilter] = useState<string>('');
	const [isShowAvailableOnly, setIsShowAvailableOnly] = useState<boolean>(false);
	const {
		filteredPartneredTeamList,
		filteredTeamList,
		filters,
		handleFilterChange,
		handleTeamCheckboxChange,
		isLoading,
		isTeamCardDisabled,
		selectedTeamIdsSet,
		selectedTeamsCountText
	} = useWCPledgeTokensTab(searchText, selectedFilter, isShowAvailableOnly, setSelectedFilter);
	const {
		settings: { isWcPledgePhase2Enabled }
	} = useSettings();

	return (
		<S.TabContentContainer>
			<WCPledgeSearchSection
				filters={filters}
				handleFilterChange={handleFilterChange}
				isShowAvailableOnly={isShowAvailableOnly}
				searchPlaceholder={searchPlaceholder}
				selectAllCheckboxLabel={selectAllCheckboxLabel}
				selectedTeamsCountText={selectedTeamsCountText}
				setIsShowAvailableOnly={setIsShowAvailableOnly}
				setSearchText={setSearchText}
				title={title}
				toggleLabel={filtersTexts.showAvailableOnly}
			/>
			<S.ListContainer>
				{isWcPledgePhase2Enabled &&
					filteredPartneredTeamList.map(team => (
						<WCPledgePartneredTeamCard country={team} isLoading={isLoading} key={team.name} />
					))}
				{filteredTeamList.map(team => (
					<WCPledgeCountryCard
						country={team}
						handleCountryCheckboxChange={handleTeamCheckboxChange}
						isDisabled={isTeamCardDisabled(team)}
						isDisqualified={team.status === 'Failed'}
						isLoading={isLoading}
						isSelected={selectedTeamIdsSet.has(team.id)}
						key={team.name}
					/>
				))}
			</S.ListContainer>
		</S.TabContentContainer>
	);
};
